<template>
	<BaseSelect ref="BaseSelect" v-model="model" :label="label" :options="options" v-on="$listeners" v-bind="$attrs" :required="required" />
</template>

<script>
import BaseSelect from '@/components/forms/inputs/BaseSelect';
import Validate from '@/mixins/Validate';

export default {
	name: 'YesNoSelect',
	components: { BaseSelect },
	mixins: [Validate],
	props: {
		label: { required: true },
		value: { default: null },
		required: {},
	},
	computed: {
		model: {
			get() {
				return this.value;
			},
			set(v) {
				this.$emit('input', v);
			},
		},
	},
	data() {
		return {
			options: [
				{ display: this.$t('general.yes'), value: true },
				{ display: this.$t('general.no'), value: false },
			],
		};
	},
};
</script>
